import React from "react";
import {
  FixMeLater,
  LineAnnotation,
  PrecisionConfig,
  ProcessedSignalTargets,
} from "@shared/types";
import { OrdersErrors, OrderTypes } from "@shared/features/trades/common/types";
import {
  AddTarget,
  CancelTarget,
  EditTargetData,
  EditTargetOrZone,
  MoveTargetToCurrentPrice,
  UpdateTarget,
} from "@shared/features/signals/EditSignal/types";

export type EditSignalContextOptions = {
  precisionConfig?: PrecisionConfig;
  currentPrice: number;
  entryTargets: EditTargetOrZone[];
  takeProfitTargets: EditTargetData[];
  stopTargets: EditTargetData[];
  setEntryTargets: (targets: EditTargetOrZone[]) => void;
  setTakeProfitTargets: (targets: EditTargetOrZone[]) => void;
  setStopTargets: (targets: EditTargetOrZone[]) => void;
  updateTarget: UpdateTarget;
  getTargetsByType: (targetType: OrderTypes) => EditTargetOrZone[];
  isEdit: boolean;
  cancelTarget: CancelTarget;
  addTarget: AddTarget;
  confirmWithCallback: (message: string) => Promise<boolean>;
  signalData?: ProcessedSignalTargets;
  onCancelChangesClick: (onCancelChangesCallback?: () => void) => void;
  onValuesModified: () => void;
  targetsErrors: OrdersErrors;
  moveTargetToCurrentPrice: MoveTargetToCurrentPrice;
  moveStopTargetToBreakEvenPrice: (
    entryTargetsToCancel: EditTargetOrZone[]
  ) => void;
  onSaveChangesClick: () => void;
  editSignalLoading: boolean;
  generalConfiguration: FixMeLater;
  editSignalConfigurationLoading: boolean;
  setTargetsByType: (
    targetType: OrderTypes,
    targets: EditTargetOrZone[]
  ) => void;
  targetsAnnotations: LineAnnotation[];
};
export const EditSignalContext = React.createContext<
  EditSignalContextOptions | undefined
>(undefined);
